import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
//import { LiquidCache } from 'ngx-liquid-cache';
import { Observable, pipe, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";

@Injectable({
    providedIn: "root",
})
export class TalentPayrollService {
    constructor(
        private http: HttpClient,
        private _apiroot: BaseUrlHelperService,
        private log: NbcLoggerService
    ) {}

    getPayrollTimesheetQuery(
        BusinessUnit,
        currentPage?,
        pageSize?,
        totalRecords?
    ) {
        return {
            batch_id: 1,
            BUBeingUsed: BusinessUnit || 0,
            currentPage: currentPage || 1,
            pageSize: pageSize || 25,
            totalRecords: totalRecords || 0,
            sortByColumn: "",
            reverseSort: false,
            searchOptionId: null,
            searchTerm: null,
            employeeType: "",
            workState: "",
            queueStatus: "",
            workflowStatus: "",
            eventShowName: "",
            contactName: "",
            sso: "",
            perNer: "",
            wbse: "",
            CostCenter: "",
            LoggedInDept: 1,
            timecardDateFrom: "",
            timecardDateTo: "",
            processedDate: "",
        };
    }

    getTimesheetsWithQuery(talentTimesheetQuery): Observable<any> {
        return this.http
            .post(
                this._apiroot.baseUrl + "talentPayroll/timecards/Get",
                talentTimesheetQuery
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //@LiquidCache("getJobCodes")
    getJobCodes(): Observable<any> {
        return this.http.get(this._apiroot.baseUrl + "payroll/jobcodes").pipe(
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    //@LiquidCache("getContractCodes")
    getContractCodes(): Observable<any> {
        return this.http
            .get(this._apiroot.baseUrl + "payroll/contractcodes")
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    /*
     * Method can be used to insert/update the timecard(s)
     */
    upsertTimecards(buid, timesheets): Observable<any> {
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/upsert",
                timesheets
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    assignContact(buid, timecards): Observable<any> {
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/assignContact",
                timecards
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    ///clone functionality. Only OPS fields allowed
    clone(buid, timesheets): Observable<any> {
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/clone",
                timesheets
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    /*method to unlock the timecards*/
    unlock(buid, timesheets): Observable<any> {
        this.log.trace("talentPayroll: unlock timecards");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/unlock",
                timesheets
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    //method used to update & submit the timecards
    submitTimecards(buid, timesheets): Observable<any> {
        this.log.trace("talentPayroll: upsert timecards");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/submit",
                timesheets
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    /*
     * Method will be used to split timecard for aftra values
     */
    splitAftraTimecard(buid, timecards): Observable<any> {
        this.log.trace("Split Aftra Timecard");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/split",
                timecards
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    rejectTimecard(buid, timecards) {
        this.log.trace("talentPayroll: upsert timecards");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/reject",
                timecards
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    spbStatusUpdate(businessUnitId, timecards, status): Observable<any> {
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    businessUnitId +
                    "/timecards/spbStatus/" +
                    status,
                timecards
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    getTimesheets(batchId): Observable<any> {
        this.log.trace("talentPayroll: get TalentTimesheet Detail");
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/timesheets/Get/" +
                    batchId
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    /*
     * Method can be used to resync contact
     */
    resyncContact(buid, timesheets): Observable<any> {
        this.log.trace("talentPayroll: resyncContact");
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/" +
                    buid +
                    "/timecards/resyncContact",
                timesheets
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    previewTimecards(businessUnitId): Observable<any> {
        const createdDateTime = new Date();
        const userName =
            window.preload.user.firstName + " " + window.preload.user.lastName;

        const body = {
            createdBy: userName,
            createdDate: createdDateTime.toDateString(),
            createdTime: createdDateTime.toTimeString(),
            hours: createdDateTime.getHours(),
            minutes: createdDateTime.getMinutes(),
            timeZone: createdDateTime.getTimezoneOffset(),
        };
        const options = {
            responseType: "arraybuffer",
            headers: {
                "Content-type": "application/json",
                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
        };
        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/timecards/" +
                    businessUnitId +
                    "/preview",
                body,
                {
                    responseType: "arraybuffer",
                    observe: "response",
                    headers: {
                        "Content-type": "application/json",
                        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                }
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    /*
     * Method will be used to export timecard for STB
     */
    exportTimecards(businessUnitId): Observable<any> {
        return this.http
            .get(
                this._apiroot.baseUrl +
                    "talentPayroll/timecards/export/" +
                    businessUnitId
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    exportreportTimecard(
        talentTimesheetQuery,
        businessUnitName,
        reportName
    ): Observable<any> {
        const createdDateTime = new Date();
        const userName =
            window.preload.user.firstName + " " + window.preload.user.lastName;
        const inputInfo = {
            query: talentTimesheetQuery,
            jsonData: {
                businessUnit: businessUnitName,
                reportName: reportName,
                createdBy: userName,
                createdDate: createdDateTime.toDateString(),
                createdTime: createdDateTime.toTimeString(),
                hours: createdDateTime.getHours(),
                minutes: createdDateTime.getMinutes(),
                seconds: createdDateTime.getSeconds(),
                timeZone: createdDateTime.getTimezoneOffset(),
            },
        };

        return this.http
            .post(
                this._apiroot.baseUrl +
                    "talentPayroll/timecards/report/export/",
                inputInfo,
                {
                    responseType: "arraybuffer",
                    observe: "response",
                    headers: {
                        "Content-type": "application/json",
                        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                }
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }

    importTimecards(importfile): Observable<any> {
        const formData = new FormData();
        //const headers = { 'Content-Type': undefined };
        formData.append("importfile", importfile, importfile.name);
        return this.http
            .post(
                this._apiroot.baseUrl + "talentPayroll/timecards/import",
                formData,
                {
                    headers: {
                        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                }
            )
            .pipe(
                catchError((err) => {
                    return throwError(err);
                })
            );
    }
}
